var _path, _g, _g2;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWrongAnswer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "emoji-83",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "410px",
    height: "410px",
    viewBox: "0 0 410 410",
    style: {
      enableBackground: "new 0 0 410 410"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "color"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -492.4233,
    y1: 628.8873,
    x2: -228.2586,
    y2: 628.8873,
    gradientTransform: "matrix(1.4927 0 0 -1.4927 742.8799 1143.7399)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FAAB3D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFD700"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_1_)"
    },
    d: "M205,5c262.9,4.5,262.9,395.5,0,400C-57.9,400.5-57.9,9.5,205,5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M8.2,178.8l178.7-95.5l192,27.6C294.9-56.1,29.9-15.2,8.2,178.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "shadow"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.35
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M215,385C74,388.2-26.7,233.1,31.3,105.7c-131.8,245.5,242.2,429.6,357.4,178.6C354.2,344.4,289.3,385,215,385z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "stroke"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 9.9999,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 9.9999
    },
    d: " M205,5c262.9,4.5,262.9,395.5,0,400C-57.9,400.5-57.9,9.5,205,5z"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 10,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 106,
    y1: 31.2,
    x2: 349.1,
    y2: 66.3
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 10,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 62.4,
    y1: 64.7,
    x2: 381.6,
    y2: 111
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 10,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 120.8,
    y1: 74.2,
    x2: 22.2,
    y2: 122.5
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 10,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 251.1,
    y1: 10.3,
    x2: 185.2,
    y2: 42.6
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 10,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 251.5,
    y1: 51.7,
    x2: 297.6,
    y2: 27.7
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 10,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 6.6,
    y1: 179.6,
    x2: 190.9,
    y2: 83.4
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 10,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M134.7,134.2c37.5,0,37.5,79.6,0,79.6C97.2,213.8,97.2,134.2,134.7,134.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 10,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M275.3,134.2c37.4,0,37.5,79.6,0,79.6C237.7,213.2,237.7,134.8,275.3,134.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M143.5,159.2c11.4-0.3,11.4,24.3,0,24C132.1,183.5,132.1,158.9,143.5,159.2z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M134.7,134.2c37.5,0,37.5,79.6,0,79.6C97.2,213.8,97.2,134.2,134.7,134.2z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M143.5,149.9c11.4-0.3,11.4,24.3,0,24C132.1,174.2,132.1,149.6,143.5,149.9z"
  }), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M275.3,134.2c37.4,0,37.5,79.6,0,79.6C237.7,213.2,237.7,134.8,275.3,134.2z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M285,149.9c11.4-0.3,11.4,24.3,0,24C273.5,174.1,273.7,149.7,285,149.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 10,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M165.2,260.2c0,0,63.6-16.7,110.2,24.7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrongAnswer);
export default __webpack_public_path__ + "static/media/wrong_answer.619fb0152de5280ac47d3fb11923fb9d.svg";
export { ForwardRef as ReactComponent };